import { createReducer } from '@reduxjs/toolkit'
import * as actions from '../../actions/GlobalFilter/actions'
import * as authenticationActions from '../../actions/Authentication/actions'
import { GlobalFilterVariant } from 'types/GlobalGlobalFilter'

export type GlobalFilterStore = {
  variant: GlobalFilterVariant
  customSelected: string[]
  companyGroupId: string | null
  isInitialized: boolean
}

const INITIAL_STATE: GlobalFilterStore = {
  variant: GlobalFilterVariant.ALL,
  customSelected: [],
  companyGroupId: null,
  isInitialized: false
}

const GlobalFilterReducer = createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(actions.initialize, (state, action) => {
      state.variant = action.payload.variant
      state.customSelected = action.payload.customSelected
      state.companyGroupId =
        action.payload.companyGroupId
      state.isInitialized = true
    })
    .addCase(actions.update, (state, action) => {
      state.variant = action.payload.variant
      state.customSelected = action.payload.customSelected
      state.companyGroupId =
        action.payload.companyGroupId
    })
    .addCase(authenticationActions.signOut, () => INITIAL_STATE)
    .addDefaultCase((state) => state)
})

export default GlobalFilterReducer
